/**
 * Flachdach: die Flaeche liegt bei 0 Grad, die Module stehen aufgestaendert
 * (PV-D14). Beides getrennt zu fuehren ist noetig, weil der Reihenabstand
 * daran haengt (PV-F07).
 */
import { gradInBogen } from './typen.js';
/**
 * Reihenabstand, damit sich die Reihen nicht gegenseitig verschatten.
 *
 * Vorschlagswert, ueberschreibbar — das Programm rechnet nicht die Verschattung
 * durch, es haelt nur den ueblichen Daumenwert nach (Spec: keine Simulation,
 * kein zweites PV*SOL).
 */
export function reihengeometrie(modullaengeM, auf) {
    const alpha = gradInBogen(auf.aufstaenderungGrad);
    const gamma = gradInBogen(auf.sonnenstandGrad);
    if (auf.sonnenstandGrad <= 0 || auf.sonnenstandGrad >= 90) {
        throw new Error('reihengeometrie: Sonnenstand muss zwischen 0 und 90 Grad liegen');
    }
    const modultiefeM = modullaengeM * Math.cos(alpha);
    const hoeheM = modullaengeM * Math.sin(alpha);
    const schattenM = hoeheM / Math.tan(gamma);
    return {
        modultiefeM,
        hoeheM,
        schattenM,
        reihenabstandM: modultiefeM + schattenM,
    };
}
//# sourceMappingURL=flachdach.js.map